// extracted by mini-css-extract-plugin
export default {"store-button":"omI3t","store-button__img":"C8FDq","store-button--appStore":"c51uM"};